import { render } from "./ReportsView.vue?vue&type=template&id=763687e8"
import script from "./ReportsView.vue?vue&type=script&lang=js"
export * from "./ReportsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__